import { rgba } from 'polished';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../design-system/colors';
import { FlexDiv } from '../../../design-system/containers';
import { Heading3 } from '../../../design-system/headings';
import { TextDefault } from '../../../design-system/texts';
import { ThemedButton } from '../../../themed/themed-button/ThemedButton';
import StartDecisionIcon from '../StartDecisionIcon';

export default function StartFeedback({ startDecisionsSubjectVideo }) {
    const { t } = useTranslation();

    return (
        <>
            <FlexDiv
                positionAbsolute
                justifyCenter
                alignCenter
                zIndex={2}
                fullWidth
                fullHeight
                desktopOnly
            >
                <FlexDiv
                    backgroundColor={rgba(palette.graphite.white, 0.9)}
                    justifyCenter
                    alignCenter
                    padding={24}
                    width={400}
                    column
                    gap={24}
                    borderRadius={8}
                >
                    <StartDecisionIcon />
                    <Heading3 mt={16}>
                        {t('decisionSubjectStartFeedbackTitle')}
                    </Heading3>
                    <TextDefault center>
                        {t('decisionSubjectStartFeedbackDescription')}
                    </TextDefault>
                    <ThemedButton
                        mode="secondary"
                        onClick={startDecisionsSubjectVideo}
                        text={t('decisionSubjectStartFeedbackButton')}
                    >
                    </ThemedButton>
                </FlexDiv>
            </FlexDiv>
            <FlexDiv
                positionAbsolute
                justifyCenter
                alignCenter
                zIndex={2}
                fullWidth
                fullHeight
                mobileOnly
                column
                onClick={startDecisionsSubjectVideo}
            >
                <StartDecisionIcon />
                <Heading3 mt={16} color={palette.graphite.white}>
                    {t('decisionSubjectStartFeedbackTitle')}
                </Heading3>
            </FlexDiv>
        </>
    );
}
